export const pageVariables = {
    headers: [
        'SIGLA', 'NOME', 'CAPITAL', 'PRÊMIO (MENSUAL)', 'CRIADO EM'
    ],
    inputs: [
        {
            name: 'sigla',
            label: 'Sigla',
            type: 'input',
            placeholder: 'Ex: DEC, FUNERAL',
            required: true
        },
        {
            name: 'nome',
            label: 'Nome do Produto',
            type: 'input',
            placeholder: 'Ex: Auxílio Funeral Master',
            required: true
        },
        {
            name: 'valor_capital',
            label: 'Valor de Capital (Indenização)',
            type: 'number',
            placeholder: '0.00',
            required: true
        },
        {
            name: 'valor_premio',
            label: 'Valor do Prêmio (Mensalidade)',
            type: 'number',
            placeholder: '0.00',
            required: true
        },
    ],
    headerInfo: {
        title: 'Gestão de Decessos',
        description: 'Cadastre e gerencie os produtos de auxílio funeral disponíveis para os planos.'
    },
    seachFilterKey: 'nome',
};
